import _isNil from "lodash/isNil";
import { format } from 'date-fns';
import { getDateFnsLocale } from '../../../extensions/';
import validateDate from './validateDate';
export default function formatDateTime(value, dateFormat) {
  const validatedDate = validateDate(value);
  if (_isNil(validatedDate)) {
    return null;
  }
  return format(validatedDate, dateFormat, {
    locale: getDateFnsLocale()
  });
}